import React from 'react';

// `variant` controls which asset is used:
//  - "colour" (default): for light/cream backgrounds (header, footer-light)
//  - "white": for dark backgrounds (dark footer, image overlays)
const Logo = ({ className = '', variant = 'colour' }) => {
  const src = variant === 'white' ? '/Whitelogo.png' : '/ColourLogo.png';
  return (
    <img
      src={src}
      alt="The Family Legacy Bridge"
      className={`h-14 w-auto ${className}`}
    />
  );
};

export default Logo;
